import {
    lazyUpdateRibbonState,
    lazyUpdateSecondClassState,
    RibbonViewState,
} from 'owa-editor-ribbonplugin-store';
import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';
import { callEditorApi } from 'owa-editor/lib/utils/callEditorApi';

const createWrapper = (
    viewState: EditorViewState | undefined,
    ribbonViewState: RibbonViewState | undefined,
    callback?: () => void,
    updateRibbonState: boolean = true
) => {
    return () => {
        if (!!viewState && !!ribbonViewState) {
            callback?.();
            if (updateRibbonState) {
                lazyUpdateRibbonState.importAndExecute(viewState, ribbonViewState);
            } else {
                lazyUpdateSecondClassState.importAndExecute(
                    ribbonViewState.formatViewState,
                    callEditorApi(viewState, 'getStyleBasedFormatState')
                );
            }
        }
    };
};

export default createWrapper;
